import React from "react";
import { useLang } from "../i18n";

const WHY_IMG = "/images/why_couple.jpg";

export default function WhyDifferent() {
  const { t } = useLang();
  return (
    <section id="different" data-testid="why-different" className="py-28 md:py-40 bg-[#F7F1E8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-14 md:gap-20 items-center">
        <div className="md:col-span-6 order-2 md:order-1">
          <p className="text-xs uppercase tracking-[0.28em] text-[#5E7891] mb-6">{t.why.eyebrow}</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.04] text-[#2D3640]">{t.why.title}</h2>
          <div className="mt-12 space-y-8">
            {t.why.points.map((p, i) => (
              <div key={i} data-testid={`why-${i}`} className="flex gap-5">
                <div className="font-serif-display text-4xl md:text-5xl text-[#8D869B] leading-none w-12 shrink-0">0{i + 1}</div>
                <div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-[#2D3640]">{p.t}</h3>
                  <p className="mt-2 text-[15px] md:text-base text-[#4A5A6B] leading-relaxed max-w-md">{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="md:col-span-6 order-1 md:order-2">
          <figure className="relative aspect-[4/5] rounded-[28px] overflow-hidden border border-[#E5D9C0] shadow-[0_40px_100px_-45px_rgba(132,118,137,0.5)]">
            <img src={WHY_IMG} alt="A couple embracing at sunset overlooking Porto and the river" loading="lazy" className="w-full h-full object-cover object-center" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2D3640]/25 via-transparent to-transparent" />
          </figure>
        </div>
      </div>
    </section>
  );
}
